const applet = '/p/teste';

const view = `${applet}/redefinir_email/:cid`;

const urls = {
  get: {
    validateCid: '/v1/pub/validar_solicitacao_email/:cid',
  },
  post: {
    changeEmail: '/v1/pub/redefinicao_email_senha/:solicitationID',
  },
};

export { applet, view, urls };
